import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import moment from "moment";
import { selectEquipmentEPI, updateFilteredList } from "../../redux/epi/epiActions";
import "./EquipmentsEPITable.css";
import { ALL_SELECT_OPTION } from "../../constants";
import TableWithoutPaginationOrange from "../Table/TableWithoutPaginationOrange"
import "./EquipmentsEPI.css";
import "../../utils.css";
import { generateControlForm, deleteEquipment } from "../../redux/epi/epiActions";
import { openEquipmentEPIForm } from "../../redux/epi/epiEditionActions";
import IconButton from "@mui/material/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePen, faHammer, faBan, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { throwWarning, throwInfo } from "../../lib/error_helper";

class EquipmentsEPITable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            getFilteredEquipmentsEPI: this.getFilteredEquipmentsEPI,
            filteredEquipmentsEPI: this.getFilteredEquipmentsEPI(props),
            columns: [
                    {
                        Header: "Catégorie",
                        id: "Category",
                        className: "linebreak",
                        accessor: (e) => e,
                        Cell: ({ value }) => {
                            if (!value) return null;

                            if (this.props.coworkersEquipmentsEPI) {
                                if (!value.equipment_id.agency_equipment && value.emp_id.id) {
                                    return (
                                        <div className="linebreak">
                                            <div>
                                                {value.equipment_id.name + " "}
                                                {value.state === 'to_repair' ?  
                                                <FontAwesomeIcon
                                                    icon={faHammer}
                                                    alt="Interventions"
                                                /> 
                                                : value.state === 'obsolete' ?                                     
                                                <FontAwesomeIcon
                                                    icon={faBan}
                                                    alt="Interventions"
                                                /> 
                                                : 
                                                null} 
                                                {'\n'}
                                                {"(" + value.emp_id.first_name + " " + value.emp_id.last_name + ")"}
                                            </div>                                     
                                        </div>
                                    );
                                } else if (value.equipment_id.agency_equipment) {
                                    return (
                                        <div className="linebreak">
                                            <div>
                                                {value.equipment_id.name  + " "} 
                                                {value.state === 'to_repair' ?  
                                                <FontAwesomeIcon
                                                    icon={faHammer}
                                                    alt="Interventions"
                                                /> 
                                                : value.state === 'obsolete' ?                                     
                                                <FontAwesomeIcon
                                                    icon={faBan}
                                                    alt="Interventions"
                                                /> 
                                                : 
                                                null} 
                                                {'\n'}
                                                {"(commun)"}
                                            </div>                                    
                                        </div>
                                    );
                                }
                            } 

                            return (
                                <div className="linebreak">
                                    {value.equipment_id.name  + " "}   
                                    {value.state === 'to_repair' ?  
                                    <FontAwesomeIcon
                                        icon={faHammer}
                                        alt="Interventions"
                                    /> 
                                    : value.state === 'obsolete' ?                                     
                                    <FontAwesomeIcon
                                        icon={faBan}
                                        alt="Interventions"
                                    /> 
                                    : 
                                    null}                                 
                                </div>
                            );
                        },
                    },
                    {
                        Header: "Marque\nModèle\nN° série",
                        className: "linebreak",
                        accessor: (e) => e.brand + "\n" + e.model + "\n" + e.serial_number,
                    },
                    {
                        Header: "Date fin de validité",
                        id: "validity_end_date",
                        accessor: (e) => e.validity_end_date ? moment(e.validity_end_date).format("DD/MM/YYYY") : "",
                    },
                    {
                        Header: () => {
                            return (
                                <div style={{display: "flex", justifyContent: "flex-end"}}>
                                    {this.props.myEquipmentsEPI ? 
                                        <div style={{display: "flex", justifyContent: "flex-end", height: "100%"}}> 
                                            <div style={{display: "inline-block", alignItems: "center"}}>
                                                <IconButton 
                                                sx= {{color: "#5710FE"}} 
                                                aria-label="edit form" onClick={() => this.openAddEquipmentWindow()}>
                                                    <FontAwesomeIcon
                                                        icon={faPlus}
                                                        alt="Ajout"
                                                        className="fa-w-18"
                                                    />
                                                </IconButton>
                                            </div>                                     
                                        </div>
                                        : 
                                        null
                                    }                                      
                                </div>                                
                            );
                        },
                        id: "form",
                        accessor: (e) => e,
                        Cell: ({ value }) => {
                            let canDelete = true;
                            if (value.brand ||
                                value.model ||
                                value.serial_number ||
                                value.number_forms > 0 ||
                                value.equipment_id.is_obligatory) 
                            {
                                canDelete = false;
                            }

                            return (
                                <div style={{display: "flex", justifyContent: "flex-end"}}>
                                    {
                                        this.props.myEquipmentsEPI && canDelete && 
                                        !value.equipment_id.agency_equipment ?     
                                        <div style={{display: "inline-block"}}>
                                            <IconButton  color="primary" aria-label="edit form" onClick={() => this.askUser(value.id)}>
                                                <FontAwesomeIcon
                                                    icon={faTrash}
                                                    alt="Suppression"
                                                    className="fa-w-18"
                                                />
                                            </IconButton>
                                        </div> : 
                                        null
                                    } 
                                    {value.equipment_id.survey_id && value.state !== "draft" ? 
                                        <div style={{display: "inline-block"}}>
                                            <IconButton  color="primary" aria-label="edit form" onClick={() => this.openEquipmentEPIForm(value.id)}>
                                                <FontAwesomeIcon
                                                    icon={faFilePen}
                                                    alt="Formulaire"
                                                    className="fa-w-18"
                                                />
                                            </IconButton>
                                        </div> : 
                                        null
                                    }                                                                          
                                </div>                                
                            );
                        },
                    }
            ],
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;

        modifiedState.filteredEquipmentsEPI = prevState.getFilteredEquipmentsEPI(nextProps);
        return modifiedState;
    }

    getFilteredEquipmentsEPI(props) {
        let filteredEquipmentsEPI = props.equipmentsEPI;
        let filters = props.epiFilters[props.filtersInstance];

        if (!filters.employees.includes(ALL_SELECT_OPTION))
            filteredEquipmentsEPI = filteredEquipmentsEPI.filter((e) => filters.employees.includes(e.emp_id.id));
        
        /* Filtre département dissimulé pour le moment */
        // if (!filters.departments.includes(ALL_SELECT_OPTION))
        //     filteredEquipmentsEPI = filteredEquipmentsEPI.filter((e) => filters.departments.includes(e.department_id.id));

        if (!filters.equipmentTypes.includes(ALL_SELECT_OPTION))
            filteredEquipmentsEPI = filteredEquipmentsEPI.filter((e) => filters.equipmentTypes.includes(e.equipment_id.agency_equipment));

        if (!filters.categories.includes(ALL_SELECT_OPTION))
            filteredEquipmentsEPI = filteredEquipmentsEPI.filter((e) => filters.categories.includes(e.equipment_id.name.trim()));
        
        if (!filters.models.includes(ALL_SELECT_OPTION))
            filteredEquipmentsEPI = filteredEquipmentsEPI.filter((e) => filters.models.includes(e.model.trim()));

        if (!filters.brands.includes(ALL_SELECT_OPTION))
            filteredEquipmentsEPI = filteredEquipmentsEPI.filter((e) => filters.brands.includes(e.brand.trim()));
        
        if (!filters.serialNumbers.includes(ALL_SELECT_OPTION))
            filteredEquipmentsEPI = filteredEquipmentsEPI.filter((e) => filters.serialNumbers.includes(e.serial_number.trim()));

        return filteredEquipmentsEPI;
    }

    getTableTrProps(row, cell) {
        if (row) {
            var toCheck = false;
            if (row.original.validity_end_date) {
                let validity_end_date = moment(row.original.validity_end_date);
                let today = moment();                
                if (validity_end_date < today || validity_end_date.diff(today, 'months', true) <= 2) {
                    toCheck = true;
                }
            } else {
                toCheck = true;
            }
            return {
                className: ((this.props.myEquipmentsEPI && row.original.state === "operational" && toCheck) ? "epi-to-check" : "") + 
                            (this.props.myEquipmentsEPI && row.original.state === "draft" ? " italic" : ""),
                onClick: function () {
                    let canDelete = true;
                    if (cell.value.brand ||
                        cell.value.model ||
                        cell.value.serial_number ||
                        cell.value.number_forms > 0) 
                    {
                        canDelete = false;
                    }
                    var requiredFieldsFilled = true;
                    if (!cell.value.brand && cell.value.brand_required || 
                        !cell.value.model && cell.value.model_required ||
                        !cell.value.serial_number && cell.value.serial_number_required) 
                    {
                        requiredFieldsFilled = false;
                    }
                    if (cell && cell.column.id == "form") {
                        if ((cell.value.equipment_id.survey_id &&  cell.value.state !== "draft" && requiredFieldsFilled) ||
                            (this.props.myEquipmentsEPI && canDelete && !cell.value.equipment_id.agency_equipment)) {
                            return; 
                        }
                    } 

                    let currentEquipmentEPIIndex = this.state.filteredEquipmentsEPI.findIndex(x => x.id === row.original.id);
                    this.props.updateFilteredList(this.state.filteredEquipmentsEPI);
                    this.props.selectEquipmentEPI(row.original, currentEquipmentEPIIndex); 
                    this.props.history.push("/epis/epi");            
                }.bind(this),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {};
        }
    }

    openEquipmentEPIForm(equipmentId) {    
        let equipment = this.state.filteredEquipmentsEPI.find(x => x.id === equipmentId);        
        let currentEquipmentEPIIndex = this.state.filteredEquipmentsEPI.findIndex(x => x.id === equipmentId);
        this.props.updateFilteredList(this.state.filteredEquipmentsEPI);
        this.props.selectEquipmentEPI(equipment, currentEquipmentEPIIndex);
        if (equipment.brand_required && !equipment.brand || equipment.model_required && !equipment.model || equipment.serial_number_required && !equipment.serial_number) {
            this.props.throwWarning({
				title: "Veuillez renseigner tous les champs obligatoires avant de remplir le formulaire.",
			});
            this.props.history.push("/epis/epi");  
            return;
        }
        this.props.generateControlForm(equipment, this.props.activeUser, () => {
            this.props.openEquipmentEPIForm(this.props.history);
        });
    }

    askUser(equipmentId) {
		this.props.throwInfo({
			title: "Le modèle, la marque et le numéro de série de l'équipement ne sont pas renseignés. " + 
            "Il peut donc être supprimé. Êtes-vous sûr(e) de vouloir le supprimer ?",
			dismissAfter: 0,
			forceDismissible: true,
			buttons: [{name: "Oui", primary: true, onClick: () => {this.deleteEquipment(equipmentId)}}, {name: "Non", primary: false, onClick: () => {}}]
		});
	}

    deleteEquipment(equipmentId) {
        this.props.deleteEquipment(equipmentId, this.props.activeUser, () => {
            window.location.reload();
        });
    }

    openAddEquipmentWindow() {    
        this.props.history.push("/epis/declare");  
    }

    render() {
        return (
            <div className="flex-div flex-grow-1">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding equipment-epi-table flex-grow-1">
                    <TableWithoutPaginationOrange
                        filterable = {false}
                        data={this.state.filteredEquipmentsEPI}
                        columns={ this.state.columns }
                        getTrProps={this.getTableTrProps.bind(this)}
                        className="tableWithoutPaginationCustomClass"
                        pageSize={1000}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        forms: state.equipmentsEPI.equipmentEPIForms,
        epiFilters: state.equipmentsEPI.epiFilters,
        openEquipmentEPIFormBool: state.equipmentEPI.openEquipmentEPIForm
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        selectEquipmentEPI: (equipmentEPI, currentEquipmentEPIIndex) => dispatch(selectEquipmentEPI(equipmentEPI, currentEquipmentEPIIndex)),
        updateFilteredList: (filteredEquipmentsEPI) => dispatch(updateFilteredList(filteredEquipmentsEPI)),
        generateControlForm: (equipmentEPI, user, onSuccess) => dispatch(generateControlForm(equipmentEPI, user, onSuccess)),
        openEquipmentEPIForm: (history) => dispatch(openEquipmentEPIForm(history)),
        deleteEquipment: (equipmentId, user, onSuccess) => dispatch(deleteEquipment(equipmentId, user, onSuccess)),
        throwWarning: (warnObj) => dispatch(throwWarning(warnObj)),
        throwInfo: (infoObj) => dispatch(throwInfo(infoObj))
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(EquipmentsEPITable);
